    <template>
      <div id="wrapper">
        <!-- Sidebar -->
          <ul class="navbar-nav sidebar sidebar-dark accordion" 
            id="accordionSidebar" style="background-color: #ba2428">

          <!-- Sidebar - Brand -->
          <a class="sidebar-brand d-flex align-items-center justify-content-center my-5">
            <div class="sidebar-brand-icon rotate-n-15"></div>
            <div class="sidebar-brand-text mx-3">
              <img src="../assets/tribeid.png" height="30" alt="">
            </div>
          </a>

          <!-- Divider -->
          <hr class="sidebar-divider my-0">

          <!-- Nav Item - Dashboard -->
          <li class="nav-item active">
            <router-link class="nav-link" :to="{name:'dashboard'}">
              <i class="fas fa-fw fa-tachometer-alt"></i>
              <span class="pl-2">Dashboard</span></router-link>
          </li>

          <!-- Divider -->
          <hr class="sidebar-divider">
          <!-- PROFILE MANAGEMENT -->
          <div class="sidebar-heading">
            PROFILE MANAGEMENT
          </div>
          <li class="nav-item">
            <router-link class="nav-link collapsed" :to="{name:'user-data-providers'}" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
              <i class="fas fa-digital-tachograph"></i>
              <span class="pl-2">Data Providers</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link collapsed" :to="{name:'user-request-entity'}" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
            <i class="fas fa-sitemap"></i>
              <span class="pl-2">Entity Resquest</span>
            </router-link>
          </li>
        <!-- END OF PROFILE MANAGEMENT -->
        <!-- ENTITITES MANAGEMENT -->
        <hr class="sidebar-divider">
          <div class="sidebar-heading">
            ENTITIES MANAGEMENT
          </div>
          <li class="nav-item" v-if="currentUser.entities && currentUser.entities.length > 0">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
              <i class="fas fa-users-cog"></i>
              <span class="pl-2">My Entities</span>
            </a>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
              <div class="bg-white py-2 collapse-inner rounded">
                <h6 class="collapse-header">My Entities :</h6>
                <a v-for="(entity,key) in currentUser.entities" :key="key" 
                    class="collapse-item link-hover"
                    @click="entityManagement(entity.id)"
                  >
                    {{entity.entity.name}}
                </a>
              </div>
            </div>
          </li>
        <!-- END OF ENTITIES MANAGEMENT -->
            <!-- <li class="nav-item">
              <router-link class="nav-link collapsed" :to="{name:'tokens'}" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
                <i class="fas fa-drumstick-bite"></i>
                <span class="pl-2">Token Management</span>
              </router-link>
            </li> -->
          <!-- Nav Item - Pages Collapse Menu -->
          <li class="nav-item" v-if="currentUser.data_provider">
            <a class="nav-link collapsed" href="#" data-toggle="collapse" 
              data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
              <i class="fas fa-user-edit"></i>
              <span class="pl-2">Entity Profile Update</span>
            </a>
            <div id="collapseTwo" class="collapse" 
              aria-labelledby="headingTwo" data-parent="#accordionSidebar">
              <div class="bg-white py-2 collapse-inner rounded">
                  <h6 class="collapse-header">Action:</h6>
                  <a class="collapse-item" href="#"
                  data-toggle="collapse"
                  data-target="#innerCollapse" >
                    <i class="fas fa-align-left"></i> 
                    <span class="pl-2">
                        Submit Form
                    </span> 
                  </a>
                    <div id="innerCollapse" class="collapse">
                      <router-link href="" class="collapse-item"
                      :to="{path:'/search-afcfta-number'}">
                        <i class="fas fa-sitemap"></i>
                        <span class="">Product Registration</span>
                      </router-link>
                    </div>
                <router-link class="collapse-item" :to="{name:'api-product-registeration'}">
                  <i class="fas fa-tape"></i> 
                  <span class="pl-2">
                    Use API
                  </span>
                </router-link>
              </div>
            </div>
          </li> 
          <hr class="sidebar-divider d-none d-md-block">
          <div class="text-center d-none d-md-inline">
            <button class="rounded-circle border-0" id="sidebarToggle"></button>
          </div>

        </ul>

        <!-- Content Wrapper -->
        <div id="content-wrapper" class="d-flex flex-column">
          <!-- Main Content -->
          <div id="content">
            <!-- Topbar -->
            <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
              <!-- Sidebar Toggle (Topbar) -->
              <button id="sidebarToggleTop" class="btn d-md-none rounded-circle mr-3">
                <i class="text-danger fa fa-bars"></i>
              </button>
            <ul class="navbar-nav ml-auto">
                <div class="topbar-divider d-none d-sm-block"></div>

                <!-- Nav Item - User Information -->
                <li class="nav-item dropdown no-arrow">
                  <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="mr-2 d-none d-lg-inline text-gray-600 small">
                        Welcome!, {{currentUser.individual.username}}
                    </span>
                    <img class="img-profile rounded-circle" src="https://source.unsplash.com/QAB-WJcbgJk/60x60">
                  </a>
                  <!-- Dropdown - User Information -->
                  <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                    <!-- <a class="dropdown-item" href="#">
                      <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                      Profile
                    </a> -->
                    <div class="dropdown-divider"></div>
                    <a @click="logout" class="dropdown-item" href="http://139.162.234.164:81/accounts/logout?service=http://localhost:8082" data-toggle="modal" data-target="#logoutModal">
                      <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                      Logout
                    </a>
                  </div>
                </li>

              </ul>

            </nav>
            <!-- End of Topbar -->

            <!-- Begin Page Content -->
            <div class="container-fluid">
              <router-view />
            </div>
            <!-- /.container-fluid -->
          </div>
          <!-- End of Main Content -->

          <!-- Footer -->
            <button class="btn btn-danger scroll-top" data-scroll="up" type="button">
              <i class="fa fa-chevron-up"></i>
            </button>
            <footer class="sticky-footer bg-white">
              <div class="container my-auto">
                <div class="copyright text-center my-auto">
                  <p>Copyright &copy; TribeId</p>
                  <p>In association with the <span style="color:black; font-weight:bolder"> African Union Open Corridors Initiative</span> </p>
                  <p>In partnership with the <span style="color:black; font-weight:bolder">AFCFT Secretariat </span></p>
                </div>
              </div>
          </footer>
          <!-- End of Footer -->
        </div>
        <!-- End of Content Wrapper -->
        <!-- 
          Start modal component
        -->
      </div>
  <!-- End of Page Wrapper -->
</template>

<script>
const $ = require('jquery')
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $('.scroll-top').fadeIn();
    } else {
      $('.scroll-top').fadeOut();
    }
  });

  $('.scroll-top').click(function () {
    $("html, body").animate({
      scrollTop: 0
    }, 100);
      return false;
  });

});
import Storage from '@/helpers/storage.js'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name:'adminDashboard',
  components: {
  },
  data() {
    return {
      entity:[],
    }
  },
  methods: {
    entityManagement(id) {
      this.$router.push(`/user/entity/${id}`)
    },
    logout() {
          Storage.removeAll()
          this.$session.remove('entity')
          window.location.replace(`http://139.162.234.164:81/accounts/logout?service=http://localhost:8082`)
        },
  },
  computed: { 
    currentUser() {
      return this.$store.getters.currentUser
    }
  }
}
</script>

<style scoped>
  .link-hover:hover{
    cursor: pointer;
  }
  .scroll-top {
  width: 75px;
  height: 75px;
  position: fixed;
  bottom: 25px;
  left: 20px;
  display: none;
}
.scroll-top i {
  display: inline-block;
  color: #fff;
}
</style>